import React, {useState, useEffect} from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import useDataApi from 'utils/useDataApi';


export default function RPCProgressBar({taskUrl, onSuccess, onError, label}) {
  // console.log("RPC Progress from ", taskUrl);
  const status = rpcProgress(taskUrl, onSuccess, onError) || { pending: true };
  // console.log("Progress", status);

  return (
    <ProgressBar
      active={status.pending}
      now={parseFloat(status.progress_percent) || 100}
      label={status.success ? '' : label }
    />)
}

function rpcProgress(url, onSuccess, onError) {
  const [{ response }, { triggerRefresh }] = useDataApi(url);

  const [progressValue, setProgressValue] = useState({});

  useEffect(() => {
    if (!response) return;

    if (response.accepted) {
      // For Stuff with no redirect URL when it's done
      if (response.body.success) {
        onSuccess(response.body);
        return;
      }

      setProgressValue(response.body);

      // wait 0.5s and then update progress again
      setTimeout(triggerRefresh, 2000);
      return;
    }

    // when progress finishes, it returns a 302 response to the actual results, but it appears that  superagent
    // follows that redirect for us, so we should have a 200 response here
    if (response.status !== 200) {
      onError(response.body);
      return;
    }

    if (response.body.error || response.body.success === false)
      onError(response.body);
    else
      onSuccess(response.body);
  }, [response]);

  return progressValue;
}



// WEBPACK FOOTER //
// ./src/components/common/RPCProgressBar.jsx